export default function () {
  const widgetName = 'footerWidget';
  const widgetOpts = footerWidgetOpts;
  const $widgetHTML = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      const cards = $widgetHTML.find('.card-widget-item');
      if (hasData) {
        if ($(cards).hasClass('void-link')) {
          $(cards).removeAttr('target');
        }
        $widgetHTML
          .clone()
          .insertBefore($('.mobile-menu-container .mobile-menu-footer-links'))
          .addClass('footer-widget-menu');
      } else {
        $widgetHTML.remove();
      }
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 3,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false,
  });
}
